import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AiInsightsService } from '../../services/ai-insights.service';

/** Sidebar count from GET /api/ai/summary. Hidden on mock data and when the count is 0. */
@Component({
  selector: 'ctv-ai-insights-unread-badge',
  templateUrl: './ai-insights-unread-badge.component.html',
  styleUrls: ['./ai-insights-unread-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AiInsightsUnreadBadgeComponent implements OnInit, OnDestroy {
  count = 0;

  get hidden(): boolean {
    return this.insights.useMock || this.count <= 0;
  }

  private readonly destroy$ = new Subject<void>();

  constructor(
    private insights: AiInsightsService,
    private cd: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    if (this.insights.useMock) {
      return;
    }
    this.insights.summary$.pipe(takeUntil(this.destroy$)).subscribe(summary => {
      this.count = (summary?.openHighSeverityAnomalies ?? 0) + (summary?.pendingRecommendations ?? 0);
      this.cd.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
